import { Injectable, inject } from '@angular/core';
import { StorePersistService } from '@app/checkout/modules/checkout-shared/services/store-persist.service';

@Injectable({ providedIn: 'root' })
export class NewFeatureGuardService {
	private readonly storePersistService = inject(StorePersistService);

	canActivate(): boolean {
		return !!this.storePersistService.getFlag('enableNewLayout');
	}
}
